export default __webpack_public_path__ + "static/media/WhatsApp Community_Bawadi.4174c885.png";